import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import type { EventContentType } from 'hb-react/shared/apps/Events/types';
import { getEventDedicatedPath } from 'hb-react/shared/apps/Events/utils/getEventDedicatedUrl';
import { AVAILABLE_CONTENT_TYPES } from 'hb-react/shared/components/ContentRecommendation/constants';

export const useNavigateToEventDetail = () => {
  const navigate = useNavigate();
  const { currentUser } = useDefaultAppContexts();
  const topicContext = useTopicContext();

  const navigateToEvent = useCallback(
    (eventId: number, contentType: EventContentType) =>
      navigate(
        getEventDedicatedPath({
          hasUser: !!currentUser,
          event: {
            id: eventId,
            type:
              contentType === AVAILABLE_CONTENT_TYPES.NETWORK_EVENT
                ? 'network_events_event'
                : 'user_event',
          },
          topicId: topicContext.topicId,
          isWhitelabelGroup: !!topicContext.whitelabelURL,
        }),
      ),
    [navigate, currentUser, topicContext],
  );

  return { navigateToEvent };
};
